import ActionPanel from './ActionPanel';

export default ActionPanel;
